var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete-dark_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".delete-dark_svg__dv{fill:url(#delete-dark_svg__ds)}.delete-dark_svg__dw{fill:#272727}.delete-dark_svg__dx{fill:url(#delete-dark_svg__du)}.delete-dark_svg__dy{fill:url(#delete-dark_svg__dt)}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "delete-dark_svg__ds",
    x1: 144.56,
    y1: 235.15,
    x2: 169.16,
    y2: 235.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "delete-dark_svg__dt",
    x1: 203.23,
    x2: 227.83,
    xlinkHref: "#delete-dark_svg__ds"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "delete-dark_svg__du",
    x1: 261.64,
    x2: 286.24,
    xlinkHref: "#delete-dark_svg__ds"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "delete-dark_svg__dw",
    d: "m354.44,72.39l-83.61-.23c-4.92-27.21-31.47-45.11-55.24-45.11-26.89,0-50.17,18.97-55.93,44.81l-84.07-.23c-6.76,0-12.28,5.5-12.3,12.27,0,3.29,1.26,6.38,3.58,8.71,2.32,2.33,5.4,3.62,8.69,3.63l10.32.03c0,3.43,0,7.41-.01,11.7,0,0-.16,254.44-.16,255.69,0,10.49,4.08,20.36,11.5,27.79,7.42,7.43,17.29,11.52,27.78,11.52h181c10.5,0,20.36-4.09,27.78-11.52,7.42-7.43,11.49-17.3,11.47-27.8l-.51-250.19c-.01-6.12-.02-11.82-.04-16.47l9.72.03c6.76,0,12.28-5.5,12.3-12.27,0-3.29-1.26-6.38-3.58-8.71-2.32-2.33-5.4-3.62-8.69-3.63Zm-138.85-20.74c11.92,0,25.3,7.98,29.84,20.44l-60.08-.17c4.98-11.94,16.93-20.28,30.24-20.28Zm104.53,61.83l.51,250.19c0,3.92-1.51,7.6-4.28,10.38s-6.45,4.3-10.36,4.3H124.98c-3.92,0-7.61-1.53-10.38-4.31s-4.3-6.47-4.3-10.39l.16-251.88s0-9.58.01-15.46l209.61.57c.01,4.66.02,10.41.04,16.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "delete-dark_svg__dv",
    d: "m144.56,157.19v155.91c0,6.78,5.52,12.3,12.3,12.3s12.3-5.52,12.3-12.3v-155.91c0-6.78-5.52-12.3-12.3-12.3s-12.3,5.52-12.3,12.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "delete-dark_svg__dy",
    d: "m203.23,157.19v155.91c0,6.78,5.52,12.3,12.3,12.3s12.3-5.52,12.3-12.3v-155.91c0-6.78-5.52-12.3-12.3-12.3s-12.3,5.52-12.3,12.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "delete-dark_svg__dx",
    d: "m273.94,144.89c-6.78,0-12.3,5.52-12.3,12.3v155.91c0,6.78,5.52,12.3,12.3,12.3s12.3-5.52,12.3-12.3v-155.91c0-6.78-5.52-12.3-12.3-12.3Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDark);
export default __webpack_public_path__ + "static/media/delete-dark.e3c85eebfdf01f2467cf7e1cc2fbe1a0.svg";
export { ForwardRef as ReactComponent };